import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListModeradores from './ListModeradores';
import UserNew from './UserNew';
import UserEdit from './UserEdit';
import TipoUsuarios from './TipoUsuarios';

import TipoUsuarioNuevo from './TipoUsuarioNuevo';
import TipoUsuarioEdit from './TipoUsuarioEdit';
import AccionPredefinidaNuevo from './AccionPredefinidaNuevo';


export default class AdmUsuarios extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListModeradores />} />
                    <Route path="NuevoUser" element={<UserNew />} />
                    <Route path="Editar/:id" element={<UserEdit />} />
                    <Route path="Editar/:id" element={<UserEdit />} />

                </Routes >
            </div >
        );
    }
}